<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addMoneyCode"
            >添加收款码</el-button
          >
        </div>
        <div class="header-right">
          <!-- <div style="margin-right: 10px">
            <span>门店：</span>
            <el-select v-model="shopId" placeholder="请选择门店" size="small">
              <el-option
                v-for="item in shopList"
                :key="item.shopStoreId"
                :label="item.shopName"
                :value="item.shopStoreId"
                >{{ item.shopName }}
              </el-option>
            </el-select>
          </div> -->
          <div style="margin-right: 10px">
            <span>收款码ID：</span>
            <el-input
              v-model="moneyNo"
              size="small"
              placeholder="请输入收款码ID"
              class="input-search"
              @keyup.enter.native="getPageData"
            >
              <el-button slot="append" @click="getPageData">查询</el-button>
            </el-input>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="moneyCodeList" style="width: 100%">
            <el-table-column label="收款码名称">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.codeName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="收款码号" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.moneyNo }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="收款码所属门店" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.storeName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="二维码贴纸" align="center">
              <template slot-scope="scope">
                <el-button size="small" type="primary" @click="showQrcode(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button size="small" type="primary" @click="edit(scope.$index)" plain
                    >修改</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowMoneyCode,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>收款二维码</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowMoneyCode = false"
          />
        </div>
        <div class="popup-container">
          <qrcode
            :value="moneyCode"
            :options="{ size: 300 }"
            class="scan-code-img"
          ></qrcode>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: showMoneyCodeModifyPop,
      }"
      style="z-index: 2000"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>{{ modifyMoneyCodeForm.moneyCodeId ? "编辑" : "创建" }}收款码</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="showMoneyCodeModifyPop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="modifyMoneyCodeForm"
            :rules="modifyMoneyCodeFormRule"
            ref="modifyMoneyCodeForm"
            label-width="128px"
          >
            <el-form-item label="收款码名称" prop="codeName">
              <el-input
                type="text"
                placeholder="请填写收款码名称"
                v-model="modifyMoneyCodeForm.codeName"
                size="small"
                ref="noinput"
                clearable
              ></el-input>
            </el-form-item>
            <template v-if="!modifyMoneyCodeForm.moneyCodeId">
              <el-form-item label="收款码编号" prop="moneyNo">
                <el-input
                  type="text"
                  placeholder="请填写收款码编号"
                  v-model="modifyMoneyCodeForm.moneyNo"
                  size="small"
                  ref="noinput"
                  clearable
                ></el-input>
                <div class="tips">查看实体二维码下面的编号</div>
              </el-form-item>
              <el-form-item label="收款激活码" prop="verifyCode">
                <el-input
                  type="text"
                  placeholder="请填写收款激活码"
                  v-model="modifyMoneyCodeForm.verifyCode"
                  size="small"
                  ref="noinput"
                  clearable
                ></el-input>
                <div class="tips">扫二维码后，出现的激活码</div>
              </el-form-item>
            </template>
            <el-form-item label="抖音来客物料ID" prop="dylifeMaterialId" v-else>
              <el-input
                type="text"
                placeholder="请填写抖音来客物料ID"
                v-model="modifyMoneyCodeForm.dylifeMaterialId"
                size="small"
                ref="noinput"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="modifyMoneyCodeFuc" :loading="isUpload"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMoneyCodeList,
  getMoneyCodeListCount,
  modifyMoneyCode,
  createMoneyCode,
  getShopList,
  singleMoneyCode,
} from "@/api/index.js";
import request from "@/utils/request";
import qrcode from "@xkeshi/vue-qrcode";

export default {
  data() {
    return {
      moneyNo: "",
      isShowMoneyCode: false,
      moneyCode: "",
      showMoneyCodeModifyPop: false,
      moneyCodeList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      isSubmit: false,
      isUpload: false,
      shopId: "",
      shopList: [],
      modifyMoneyCodeForm: {
        moneyCodeId: "",
        codeName: "",
        moneyNo: "",
        verifyCode: "",
        dylifeMaterialId: "",
      },
      modifyMoneyCodeFormRule: {
        codeName: [
          {
            required: true,
            message: "请填写收款码名称",
            trigger: "blur",
          },
        ],
        moneyNo: [
          {
            required: true,
            message: "请填写收款码编号",
            trigger: "blur",
          },
        ],
        verifyCode: [
          {
            required: true,
            message: "请填写收款激活码",
            trigger: "blur",
          },
        ],
      },
      oldDylifeMaterialId: "",
    };
  },
  components: {
    qrcode,
  },
  watch: {
    showMoneyCodeModifyPop(val) {
      if (!val) {
        this.modifyMoneyCodeForm = {
          moneyCodeId: "",
          codeName: "",
          moneyNo: "",
          verifyCode: "",
          dylifeMaterialId: "",
        };
      }
    },
  },
  mounted() {
    this.getPageData();
    // this.getShopList();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getMoneyCodeList();
      this.getMoneyCodeListCount();
    },
    getMoneyCodeList() {
      getMoneyCodeList({
        moneyNo: this.moneyNo,
        pageNo: this.pageNo,
      }).then((res) => {
        if (res.code == 1) {
          this.moneyCodeList = res.data;
        }
        if (res.code == -1) {
          this.moneyCodeList = [];
        }
      });
    },
    getMoneyCodeListCount() {
      getMoneyCodeListCount({
        moneyNo: this.moneyNo,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data.totalNum;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    getShopList() {
      getShopList({
        shopStoreId: "",
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.shopList = res.data;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getMoneyCodeList();
    },
    showQrcode(row) {
      this.moneyCode = row.qrCodeValue;
      this.isShowMoneyCode = true;
    },
    edit(index) {
      singleMoneyCode({
        moneyCodeId: this.moneyCodeList[index].moneyCodeId,
      }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.modifyMoneyCodeForm, res.data);
          this.oldDylifeMaterialId = res.data.dylifeMaterialId;
          this.showMoneyCodeModifyPop = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    addMoneyCode() {
      this.showMoneyCodeModifyPop = true;
      // this.$notify({
      //   title: "提示",
      //   message: "请下载微火APP添加",
      //   type: "warning",
      //   duration: 2000,
      // });
    },
    modifyMoneyCodeFuc() {
      this.$refs.modifyMoneyCodeForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.modifyMoneyCodeForm));
          if (params.moneyCodeId) {
            if (
              params.dylifeMaterialId &&
              params.dylifeMaterialId == this.oldDylifeMaterialId
            ) {
              delete params.dylifeMaterialId;
            }
            modifyMoneyCode(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.showMoneyCodeModifyPop = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            createMoneyCode(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "创建成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.showMoneyCodeModifyPop = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
.el-input + .el-input {
  margin-top: 10px;
}
.xls-row {
  display: flex;
}
.popup {
  .popup-container {
    padding: 10px;
    text-align: center;
    .tips {
      text-align: left;
      color: red;
      line-height: 1;
    }
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
